<template>
  <div class="reviews-banner">
    <div class="container">
      <Breadcrumbs :items="subHeader.breadcrumbs"/>
      <div class="row page-header__row v-center">
        <div class="col sm-12 page-header__col page-header__col-left d8">
          <div class="page-header__col-inner page-header__content">
            <h1 class="page-header__title">
              {{ subHeader.title }}
            </h1>
          </div>
        </div>
        <div class="col d4 sm-12 page-header__col page-header__col-right">
          <div class="page-header__col-inner">
            <ABtn
              v-if="subHeader.btn.title"
              :label="subHeader.btn.title"
              @click="handlerClick"
              class="secondary"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {useHeader} from "../../../../composables/useHeader";
import Breadcrumbs from "../../../main/Breadcrumbs";
import { ABtn } from "../../../ui";
import { useAModal } from "../../../ui";

export default {
  name: 'ReviewsPageBanner',
  props: ['result'],
  components: {
    Breadcrumbs,
    ABtn,
  },
  setup: (props, ctx) => {
    const {subHeader} = useHeader();
    const modal = useAModal();

    const handlerClick = () => {
      modal.show('reviews-page-modal');
    }

    return {
      subHeader,
      handlerClick,
    }
  },
}
</script>

<style lang="scss" scoped>
.reviews-banner {
  background-color: var(--c-secondary-200);
  color: #fff;
  min-height: 24.75rem;
  padding-top: calc(6.25rem + 3.125rem);
  padding-bottom: 3.75rem;
  height: 100%;

  :deep {
    .breadcrumbs__link {
      color: #fff;
    }
  }
}
</style>